<template>
  <transition name="slide" appear>
    <div ref="container" class="menu" :class="{ 'above-tab-bar': aboveTabBar }">
      <UserCard v-if="isAuthenticated && user" :user-avatar="user.avatar" />

      <a v-else :href="$routes.GET_STARTED" class="full-width">
        <Banner />
      </a>

      <MenuItems />
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import UserCard from '../PopupMenuContent/UserCard';
import MenuItems from '../PopupMenuContent/MenuItems';
import Banner from '../PopupMenuContent/Banner';
import { OVERLAY_TYPES } from '../../store/modules/overlay';

export default {
  name: 'Menu',
  components: {
    UserCard,
    MenuItems,
    Banner
  },

  props: {
    // The tab bar stays at the bottom while the menu is open (TabBar
    // .is-over-menu), so the menu ends above it.
    aboveTabBar: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      startX: null,
      OVERLAY_TYPES
    };
  },

  computed: {
    ...mapGetters({
      user: 'app/user',
      isAuthenticated: 'app/isAuthenticated'
    })
  },
  mounted() {
    this.setUpSwipeability();
    this.showOverlay({ show: true, type: OVERLAY_TYPES.BLUR });
  },

  beforeDestroy() {
    this.destroySwipeability();
  },

  destroyed() {
    this.hideOverlay();
  },
  methods: {
    ...mapActions({
      closeMenu: 'menu/closeMenu',
      showOverlay: 'overlay/show',
      hideOverlay: 'overlay/hide'
    }),

    checkTouchStartX: function (e) {
      if (!e.touches[0]) return; // if no support

      this.startX = e.touches[0].screenX;
    },

    checkTouchEndX: function (e) {
      if (!e.changedTouches[0]) return; // if no support

      const endX = e.changedTouches[0].screenX;

      const movementX = this.startX - endX;

      if (movementX < -50) this.closeMenu();
    },

    setUpSwipeability: function () {
      const { container } = this.$refs;

      container.addEventListener('touchstart', this.checkTouchStartX, {
        passive: true
      });
      container.addEventListener('touchend', this.checkTouchEndX, {
        passive: true
      });
    },

    destroySwipeability: function () {
      const { container } = this.$refs;
      container.removeEventListener('touchstart', this.checkTouchStartX);
      container.removeEventListener('touchend', this.checkTouchEndX);
    }
  }
};
</script>

<style lang="scss" scoped>
.menu {
  height: 100vh;
  width: 80%;
  max-width: 320px;
  position: fixed;
  top: 0;
  right: 0;
  // Grey background behind the cards, like the app.
  background-color: var(--Surface-Subtle);
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  box-sizing: border-box;
  transition: all 0.2s ease-in-out;
  z-index: $mobile-menu-z-index;
}

.above-tab-bar {
  height: auto;
  bottom: calc(#{$tab-bar-height} + env(safe-area-inset-bottom));
}

.full-width {
  width: 100%;
}

.slide-enter-active,
.slide-leave-active {
  transition-duration: 0.3s;
  transition-property: transform;
  transition-timing-function: ease;
}

.slide-enter,
.slide-leave-active {
  transform: translateX(100%);
}

a {
  text-decoration: none;
}
</style>
